import { formatInTimeZone } from 'date-fns-tz';

/** Warehouse days and periods are Europe/Warsaw dates by contract. */
const WAREHOUSE_TIME_ZONE = 'Europe/Warsaw';

export function formatDateOnly(value?: string | null): string {
  if (!value) {
    return '-';
  }
  const [year, month, day] = value.split('-');
  return `${day}.${month}.${year}`;
}

export function formatDateTime(iso?: string | null): string {
  return iso
    ? formatInTimeZone(iso, WAREHOUSE_TIME_ZONE, 'dd.MM.yyyy HH:mm')
    : '-';
}

/** `YYYY-MM-DD` of the Warsaw day the instant falls on (backend `warsawToday`). */
export function warsawDateOnly(iso: string): string {
  return formatInTimeZone(iso, WAREHOUSE_TIME_ZONE, 'yyyy-MM-dd');
}

/**
 * A timestamp's Warsaw calendar day. A KOR's `occurredAt` is its creation
 * instant, so its UTC date can be the previous day.
 */
export function formatWarsawDate(iso?: string | null): string {
  return iso ? formatDateOnly(warsawDateOnly(iso)) : '-';
}

/** "Today" is the Warsaw calendar day (contract), not the browser's. */
export function todayDateOnly(now: Date = new Date()): string {
  return formatInTimeZone(now, WAREHOUSE_TIME_ZONE, 'yyyy-MM-dd');
}
